
import { Shell } from "@/components/layout/Shell";
import { ContactForm } from "@/components/contacts/ContactForm";

export default function ContactCreatePage() {
  return (
    <Shell>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Create New Contact</h1>
          <p className="text-muted-foreground mt-2">
            Add a new contact person for your contracts
          </p>
        </div>

        <ContactForm mode="create" />
      </div>
    </Shell>
  );
}
